<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { computed, inject, provide, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Images
import logoMobile from '@/../img/logo-mobile.svg';
import logo from '@/../img/logo.svg';

// Components
import Navigation from '@/Components/Navigation/Navigation.vue';
import NavigationMobileIcon from '@/Components/Navigation/NavigationMobileIcon.vue';
import SocialIcons from './Social/SocialIcons.vue';

const route = inject('route');
const { t } = useI18n();

const menuItems = computed(() => usePage().props.menus.find((menu) => menu.name == 'main'));
const openMobileMenu = ref(false);

provide('openMobileMenu', openMobileMenu);
</script>

<template>
    <header class="fixed top-0 left-0 z-40 w-full">
        <div class="py-4 bg-white shadow-sm bg-gradient-to-r from-primary-medium to-secondary">
            <div class="container">
                <div
                    x-data="{ open: false }"
                    class="flex flex-col mx-auto xl:items-center xl:justify-between xl:flex-row"
                >
                    <div class="flex items-center justify-between">
                        <div class="flex gap-4 xl:hidden">
                            <NavigationMobileIcon :openMobileMenu="openMobileMenu" />
                        </div>

                        <Link :href="'/'" class="hidden xl:block">
                            <img class="h-16" :src="logo" alt="Logo" />
                        </Link>

                        <Link :href="'/'" class="xl:hidden shrink-0 justify-self-center">
                            <img class="w-8 h-auto" :src="logoMobile" alt="Logo" />
                        </Link>

                        <div class="xl:hidden justify-self-end">
                            <SocialIcons />
                        </div>
                    </div>

                    <div
                        class="absolute left-0 w-screen gap-10 text-black bg-gradient-to-t from-secondary-light via-secondary-light to-white xl:items-center xl:flex xl:justify-end xl:w-full top-[70px] xl:top-0 xl:relative xl:w-auto xl:bg-transparent xl:from-white xl:via-white"
                    >
                        <div :class="{ 'container w-full pt-16 z-20 xl:pt-0 h-screen xl:h-auto': openMobileMenu }">
                            <div class="flex justify-center gap-8 xl:justify-normal">
                                <Navigation :menuItems="menuItems.contents" v-if="menuItems" />

                                <SocialIcons class="hidden xl:flex" />
                            </div>

                            <div
                                class="relative z-20 flex flex-col items-start gap-3 mt-8"
                                :class="{ hidden: !openMobileMenu }"
                            ></div>
                        </div>
                        <div class="absolute w-full py-2 text-center bottom-18 bg-secondary-medium text-primary">
                            <span class="transition-colors duration-300 md:text-right hover:text-secondary">
                                {{ t('Made by:') }}
                                <a
                                    href="https://strixi.nl?utm_source=Developed+sites&utm_medium=Website&utm_campaign=Footer"
                                    target="_blank"
                                    class="font-bold"
                                    >STRIXI</a
                                >
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
